import { Injectable } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ServiceViewModel } from 'app/shared/model/service-view-model';

@Injectable()
export class ServiceControlService {

  public toFormGroup(model: ServiceViewModel[], selections?: Set<string>): UntypedFormGroup {
    const group =  new UntypedFormGroup({});
    model.forEach(service => {
      if (selections === undefined || selections.has(service.name)) {
        this.addServiceToGroup(service, group);
      }
    });
    return group;
  }

  public addServiceToGroup(service: ServiceViewModel, group: UntypedFormGroup) {
    group.addControl(service.key, new UntypedFormControl(''));
    group.addControl(service.radioKey, new UntypedFormControl(''));
    group.addControl(service.freeTextKey, new UntypedFormControl(''));
    if (service.additionalDataFields) {
      service.additionalDataFields.forEach(additionalDataField => {
        group.addControl(additionalDataField.fieldKey, new UntypedFormControl(''));
      });
    }
  }
}
